export async function awaitAllSafely<Result extends any[]>(...promises: { [ResultType in keyof Result]: Promise<Result[ResultType]> }): Promise<Result> {
  try {
    return await Promise.all(promises);
  } catch (error) {
    await Promise.allSettled(promises);
    throw error;
  }
}